import { AllowImportEnum } from '@c2b/muven-commons'

export interface ImportScopeItem {
    key: 'stock' | 'price' | 'catalog' | 'images';
    label: string;
    included: boolean;
}

const INCLUDED: Record<number, Array<ImportScopeItem['key']>> = {
    [AllowImportEnum.All]: ['stock', 'price', 'catalog', 'images'],
    [AllowImportEnum.AllExceptImages]: ['stock', 'price', 'catalog'],
    [AllowImportEnum.StockAndPrice]: ['stock', 'price'],
    [AllowImportEnum.Stock]: ['stock'],
}

const ITEMS: Array<Pick<ImportScopeItem, 'key' | 'label'>> = [
    { key: 'stock', label: 'Estoque' },
    { key: 'price', label: 'Preço' },
    { key: 'catalog', label: 'Cadastro' },
    { key: 'images', label: 'Imagens' },
]

// O que a retaguarda atualiza neste produto, item a item (lista de conferência)
export function getImportScope(allowImport: AllowImportEnum | null | undefined): ImportScopeItem[] {
    const included = INCLUDED[allowImport as number] || []

    return ITEMS.map((item) => ({ ...item, included: included.includes(item.key) }))
}
